<template>
  <AffiliateLandingPage
    welcomeGroup="Educators and Staff"
    routePath="myeducationdiscount"
  ></AffiliateLandingPage>
</template>

<script>
import AffiliateLandingPage from '@/components/Affiliate/AffiliateLandingPage.vue'

export default {
  components: {
    AffiliateLandingPage
  },
  name: 'MyEducationDiscountLandingPage'
}
</script>

<style></style>
